import { isBrowser } from "@singlestore/fusion/utils/dom";

import { STAGING_HOST } from "./url";

const LOCAL_HOSTNAMES = ["localhost", "127.0.0.1", "0.0.0.0"];

export const getEnv = () => {
    if (isBrowser) {
        const { hostname } = new URL(window.location.toString());

        if (LOCAL_HOSTNAMES.includes(hostname)) {
            return "development";
        } else if (hostname === STAGING_HOST) {
            return "staging";
        }

        return "production";
    }

    return null;
};
